import angular from 'angular';
import moment from 'moment';
import { ListagemService } from '../../../../shared/services/listagem.service';
import { Empresa, Estabelecimento } from '../../../../core/usuario/models/usuario-model';

type Session = {
  entities: {
    empresa: { empresa: string },
    estabelecimento: { estabelecimento: string },
  }
};

export class FormController {
  static $inject = [
    '$scope',
    '$rootScope',
    'ListagemService'
  ];

  public action: string;
  public tipo: string;
  public form: angular.IFormController;
  public busy: boolean = false;
  public entity;

  public filters: { empresa?: string, estabelecimento?: string } = {};
  public empresas: Empresa[];
  public estabelecimentos: Estabelecimento[];
  public listagemPermissao: string[] = ['criar_adiantamento_avulso'];
  public permissaoGrupoEmpresarial = false;

  public constructorLookupColaborador: any;

  constructor(
    public $scope: angular.IScope,
    public $rootScope: angular.IRootScopeService & {
      session: Session,
      nsjGlobals: any,
      modoGestorPermissao: (arg: string) => boolean,
      temPermissaoGrupoEmpresarial: (permissoes: string[], grupo: string) => boolean,
      liberadoTela: (arg: string) => boolean
    },
    public ListagemService: ListagemService,
  ) {
    this.filters = {
        empresa: $rootScope.session.entities.empresa.empresa,
        estabelecimento: $rootScope.session.entities.estabelecimento.estabelecimento,
    };

    this.permissaoGrupoEmpresarial = $rootScope.temPermissaoGrupoEmpresarial(
        this.listagemPermissao,
        $rootScope.nsjGlobals.a.grupoempresarial
    );

    $scope.$watch('$ctrl.entity', (newValue, oldValue: { valor: number }) => {
      if (newValue !== oldValue) {
        if (this.action !== 'retrieve') {
          this.form.$setDirty();
          if (newValue.valor <= 0) {
            this.form.valor.$setValidity('valorzero', false);
          } else {
            this.form.valor.$setValidity('valorzero', true);
          }
        }
      }

      if (this.action === 'retrieve') {
        this.entity.dataCriacaoFormatted = moment(this.entity.created_at, 'YYYY-MM-DD').format('DD/MM/YYYY');
      }
    }, true);
  }

  $onInit() {
    this.montaListagemVisibilidade();

    this.constructorLookupColaborador = {
      'empresa': this.filters.empresa,
      'estabelecimento': this.filters.estabelecimento,
      'status': '00',
      'forcagestor': this.forcaGestor(),
      ...(this.tipo && { 'tipo': this.tipo }),
    };
  }

  forcaGestor() {
    return this.$rootScope.modoGestorPermissao('criar_adiantamento_avulso');
  }

  montaListagemVisibilidade() {
    if (this.action === 'update' || this.action === 'retrieve') {
        this.filters = {
            empresa: this.entity.estabelecimentoobj.empresa,
            estabelecimento: this.entity.estabelecimentoobj.estabelecimento
        };
    }
    this.empresas = this.ListagemService.montaEmpresas(this.$rootScope.nsjGlobals.a.grupoempresarial, this.listagemPermissao);
    this.estabelecimentos = this.ListagemService.montaEstabelecimentos(this.filters.empresa!, this.empresas, this.listagemPermissao);
  }

  mudaEstabelecimentos() {
    this.estabelecimentos = this.filters.empresa ? this.ListagemService.montaEstabelecimentos(this.filters.empresa, this.empresas, this.listagemPermissao) : [];
    this.filters.estabelecimento = '';
    this.filtraEmpresaEstabelecimento();
  }

  filtraEmpresaEstabelecimento() {
    this.constructorLookupColaborador = {
      'empresa': this.filters.empresa,
      'estabelecimento': this.filters.estabelecimento,
      'status': '00',
      'forcagestor': this.forcaGestor(),
      ...(this.tipo && { 'tipo': this.tipo }),
    };
  }
}
